




















import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  props: {
    customerId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      formError: null,
    };
  },
  methods: {
    async deleteCustomer() {
      try {
        const dispatchPromise = await this.$store.dispatch(
          'sale/deleteCustomer',
          this.customerId
        );
        this.$emit('close');
        this.$emit('onSubmit', dispatchPromise);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('CUSTOMERS.NOTIFICATIONS.CUSTOMER_REMOVE_SUCCESS'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('CUSTOMERS.NOTIFICATIONS.CUSTOMER_REMOVE_ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
  },
});
